module.exports = __webpack_public_path__ + "img/KLN_logo_W.e06b95a8.png";